<script setup>
  import { useI18n } from 'vue-i18n'

  import { computed } from 'vue'

  import { useAuthStore } from '@/features/auth/useAuthStore.js'
  import LayoutUserProfileClubSelectorItem from '@/features/layout/components/userProfile/LayoutUserProfileClubSelectorItem.vue'
  import { useClubList } from '@/features/layout/components/userProfile/useClubList.js'
  import { useIsSuperAdmin } from '@/features/superAdmin/useIsSuperAdmin.js'

  const { t } = useI18n()

  const { clubs } = useClubList()

  const isSuperAdmin = useIsSuperAdmin()

  // for now last 3
  const last20Clubs = computed(() => clubs.value.slice(0, 3))

  const { myDetails } = useAuthStore()
</script>

<template>
  <div class="layout-user-profile-dropdown section">
    <h4 class="mb-1">
      {{ myDetails.email }}
    </h4>

    <div class="menu-item">
      <RouterLink to="/admin/profile" class="menu-item-link">
        <Button :label="t('profileDropdown.myProfile')" icon="pi pi-user" text />
      </RouterLink>
      <a href="/auth/logout" class="menu-item-link">
        <Button :label="t('profileDropdown.signOut')" icon="pi pi-sign-out" text
      /></a>
    </div>
  </div>

  <div v-if="!isSuperAdmin" class="section">
    <div class="title">
      <span class="title-text">
        {{ t('profileDropdown.organisations') }}
      </span>

      <RouterLink to="/auth/club-selector">
        {{ $t('common.ViewAll') }}
      </RouterLink>
    </div>

    <div class="club-items">
      <template v-for="club of last20Clubs" :key="club.name">
        <LayoutUserProfileClubSelectorItem
          v-if="club.isRegisteredFinalized"
          :desc="club.description"
          :title="club.name"
          :club-id="club.id"
          :finalized="club.isRegisteredFinalized"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .section {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .title {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 700;
    font-size: 12px;
  }

  .menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% + 10px);
    margin-left: -5px;

    .menu-item-link {
      button {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }

  .club-items {
    max-height: 200px;
    overflow-y: auto;
    @include scrollbar;
  }
</style>
